{
  "SIN": "Número de la Seguridad Social",
  "BN": "Número comercial",
  "SSN": "Número de Seguridad Social",
  "EIN": "Número de identificación del empleador",
  "ITIN": "Número de identificación fiscal individual",
  "GENERIC": "Número de identificación fiscal",
  "abbreviated": {
    "SIN": "SIN",
    "BN": "BN",
    "SSN": "SSN",
    "EIN": "EIN",
    "ITIN": "ITIN",
    "GENERIC": "NIF"
  }
}
